import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { METRIC_PALETTE, NO_DATA_COLOR } from "../../constants/airQuality";

const SAMPLE_COLOR = METRIC_PALETTE[0];
const DOT_BORDER = "#282828";
const SYMBOL_HEIGHT = 16;
const MIDDLE = SYMBOL_HEIGHT / 2;
const LINE_WIDTH = 7;
const DOT_RADIUS = 5;

const line = (to, color) => <line x1={1} y1={MIDDLE} x2={to} y2={MIDDLE} stroke={color} strokeWidth={LINE_WIDTH} />;

const dot = (x, fill, border, borderWidth = 1) => (
    <circle cx={x} cy={MIDDLE} r={DOT_RADIUS} fill={fill} stroke={border} strokeWidth={borderWidth} />
);

/**
 * Chiave della mappa di gruppo: un campione disegnato di pallino, linea, tratto stimato e grigio,
 * come appaiono sulla mappa, con la spiegazione accanto. Sotto la mappa per non coprirla, in colonna
 * (`vertical`) nella guida.
 */
export default function GroupAirQualityMapKey({ vertical = false }) {
    const { t } = useTranslation();

    const items = [
        {
            width: 14,
            symbol: dot(7, SAMPLE_COLOR, DOT_BORDER),
            text: t("groupAirQualityLegendDot", "Singola campionatura"),
        },
        {
            width: 30,
            symbol: line(29, SAMPLE_COLOR),
            text: t("groupAirQualityLegendLine", "Media delle campionature entro 150 m"),
        },
        {
            width: 46,
            symbol: (
                <>
                    <line x1={1} y1={MIDDLE} x2={29} y2={MIDDLE} stroke={SAMPLE_COLOR} strokeWidth={5} strokeOpacity={0.2} />
                    <line x1={1} y1={MIDDLE} x2={29} y2={MIDDLE} stroke={SAMPLE_COLOR} strokeWidth={4} strokeDasharray="10 8" />
                    {dot(39, "#fff", SAMPLE_COLOR, 3)}
                </>
            ),
            text: t("groupAirQualityLegendEstimated", "Posizione stimata"),
        },
        {
            width: 46,
            symbol: (
                <>
                    {line(29, NO_DATA_COLOR)}
                    {dot(39, NO_DATA_COLOR, DOT_BORDER)}
                </>
            ),
            text: t("groupAirQualityLegendGrey", "Campionatura esclusa o nessuna campionatura entro 1 km"),
        },
    ];

    return (
        <Box sx={{ display: "flex", flexDirection: vertical ? "column" : "row", flexWrap: "wrap", columnGap: 3, rowGap: 0.5 }}>
            {items.map(({ width, symbol, text }) => (
                <Box key={text} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <svg data-testid="map-key-symbol" width={width} height={SYMBOL_HEIGHT} aria-hidden="true" style={{ flexShrink: 0 }}>
                        {symbol}
                    </svg>
                    <Typography variant="body2">{text}</Typography>
                </Box>
            ))}
        </Box>
    );
}
